Ext.define('ActiveFiltersPanel', {
    extend: 'Ext.container.Container',
    xtype: 'activefilterspanel',
    layout: 'auto',
    cls: 'active-filters-panel',
    updateFilters(store, grid) {
        const me = this;
        me.removeAll();
        const filters = store.getFilters().items;
        const columns = grid.headerCt.getGridColumns();
        let fastSearchExists = false;

        filters.forEach(filter => {
            const property = filter.getProperty();
            if (property) {
                const column = columns.find(col => col.dataIndex === property);
                const headerText = column ? column.text : property;
                let val = filter.getValue();
                let operator = filter.getOperator ? filter.getOperator() : null;
                if (operator === 'eq' && val != null) {
                    if (typeof val === 'boolean') {
                        if (val) {
                            val = Lang.tak;
                        } else {
                            val = Lang.nie;
                        }
                    } else if (typeof val === 'string' && val.includes('-')) {
                        val = val.split(' ')[0];
                    }
                }
                if (operator === 'lt') {
                    if (typeof val === 'string' && val.includes('-')) {
                        val = val.split(' ')[0];
                    }
                    val = '<' + val;
                }
                if (operator === 'gt') {
                    if (typeof val === 'string' && val.includes('-')) {
                        val = val.split(' ')[0];
                    }
                    val = '>' + val;
                }
                if (operator === 'in') {
                    let labels = [];
                    let selected = Array.isArray(val) ? val : [val];

                    const filterConfig = column?.filter || {};
                    const filterStore = filterConfig.store;
                    const options = filterConfig.options;
                    const idField = filterConfig.idField || 'id';
                    const labelField = filterConfig.labelField || 'nazwa';

                    if (filterStore) {
                        filterStore.each(record => {
                            if (selected.includes(record.get(idField))) {
                                labels.push(record.get(labelField));
                            }
                        });
                    } else if (Array.isArray(options)) {
                        options.forEach(opt => {
                            const val = typeof opt === 'string' ? opt : opt[0];
                            const label = typeof opt === 'string' ? opt : opt[1];
                            if (selected.includes(val)) {
                                labels.push(label);
                            }
                        });
                    }
                    val = labels.join(', ');
                }
                const label = headerText + ' (' + (val ? val : '') + ')';
                me.add({
                    xtype: 'box',
                    cls: 'active-filter-label',
                    html: `${label} <span class="active-filter-remove">✖</span>`,
                    listeners: {
                        render: function (cmp) {
                            cmp.getEl().on('click', () => {
                                store.removeFilter(filter);
                                const panel = cmp.up('activefilterspanel');
                                if (panel?.updateFilters) {
                                    panel.updateFilters(store, grid);
                                }
                                if (grid?.saveState) {
                                    grid.saveState();
                                }
                            });
                        }
                    }
                });
            } else {
                fastSearchExists = filter.property_fastSearch != null;
            }
        });
        if (filters.length > 0 && !(filters.length === 1 && fastSearchExists)) {
            me.add({
                xtype: 'box',
                cls: 'active-filter-label-clear',
                html: `<span>${Lang.clear_all}</span>`,
                listeners: {
                    render: function (cmp) {
                        cmp.getEl().on('click', () => {
                            const filters = store.getFilters();
                            let length = filters.length;
                            if (length !== null && length !== undefined && length !== 0) {
                                for(let i = 0; i < length; i++) {
                                    store.removeFilter(filters.getAt(0));
                                }
                            }
                            // store.clearFilter(true);
                            if (me.updateFilters) {
                                me.updateFilters(store, grid);
                            }
                            if (grid?.saveState) {
                                grid.saveState();
                            }
                            let isMemoryProxy = me.isMemoryProxy(store.getProxy());
                            if (!isMemoryProxy) {
                                store.load();
                            } else {
                                store.filter();
                            }
                        });
                    }
                }
            });
        }
    },
    isMemoryProxy: function (proxy) {
        return proxy &&
            (proxy.alias?.includes('proxy.memory') ||
                proxy.isMemoryProxy ||
                proxy.$className === 'Ext.data.proxy.Memory');
    }
});